export const merchantTypeGroupOptions = [
  {
    groupName: 'MERCHANT.TYPE_CATEGORIZED.MANUFACTURER_OR_IMPORTER',
    options: [
      {
        name: 'MERCHANT.TYPE_CATEGORIZED.MANUFACTURER_OR_IMPORTER_AS_TAX_WAREHOUSE',
        value: 'MANUFACTURER_OR_IMPORTER_AS_TAX_WAREHOUSE',
      },
      {
        name: 'MERCHANT.TYPE_CATEGORIZED.MANUFACTURER_OR_IMPORTER_AS_SIMPLIFIED_TAX_WAREHOUSE',
        value: 'MANUFACTURER_OR_IMPORTER_AS_SIMPLIFIED_TAX_WAREHOUSE',
      },
      {
        name: 'MERCHANT.TYPE_CATEGORIZED.MANUFACTURER_OR_IMPORTER_AS_SMALL_SCALE_WINE_PRODUCER',
        value: 'MANUFACTURER_OR_IMPORTER_AS_SMALL_SCALE_WINE_PRODUCER',
      },
    ],
  },
  {
    groupName: 'MERCHANT.TYPE_CATEGORIZED.INTERNATIONAL_TRADER',
    options: [
      {
        name: 'MERCHANT.TYPE_CATEGORIZED.INTERNATIONAL_TRADER_AS_REGISTERED_DEALER',
        value: 'INTERNATIONAL_TRADER_AS_REGISTERED_DEALER',
      },
      {
        name: 'MERCHANT.TYPE_CATEGORIZED.INTERNATIONAL_TRADER_AS_COMMUNITY_EXCISE_WHOLESALER',
        value: 'INTERNATIONAL_TRADER_AS_COMMUNITY_EXCISE_WHOLESALER',
      },
      {
        name: 'MERCHANT.TYPE_CATEGORIZED.INTERNATIONAL_TRADER_AS_EXPORT_IMPORT_WHOLESALER',
        value: 'INTERNATIONAL_TRADER_AS_EXPORT_IMPORT_WHOLESALER',
      },
    ],
  },
  {
    name: 'MERCHANT.TYPE_CATEGORIZED.WHOLESALER_AS_IS',
    value: 'WHOLESALER_AS_IS',
    highlight: true,
  },
  {
    groupName: 'MERCHANT.TYPE_CATEGORIZED.RETAILER',
    options: [
      {
        name: 'MERCHANT.TYPE_CATEGORIZED.RETAILER_AS_HOTEL',
        value: 'RETAILER_AS_HOTEL',
      },
      {
        name: 'MERCHANT.TYPE_CATEGORIZED.RETAILER_AS_RESTAURANT',
        value: 'RETAILER_AS_RESTAURANT',
      },
      {
        name: 'MERCHANT.TYPE_CATEGORIZED.RETAILER_AS_CAFE',
        value: 'RETAILER_AS_CAFE',
      },
      {
        name: 'MERCHANT.TYPE_CATEGORIZED.RETAILER_AS_RETAIL_CHAIN',
        value: 'RETAILER_AS_RETAIL_CHAIN',
      },
      {
        name: 'MERCHANT.TYPE_CATEGORIZED.RETAILER_AS_TRAFIK',
        value: 'RETAILER_AS_TRAFIK',
      },
      {
        name: 'MERCHANT.TYPE_CATEGORIZED.RETAILER_AS_OTHER_RETAILER',
        value: 'RETAILER_AS_OTHER_RETAILER',
      },
    ],
  },
];
